import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  id: "catalog-icon",
  role: "img",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M2.25 6.50012C2.25 4.42905 3.92893 2.75012 6 2.75012H10.7302C11.1444 2.75012 11.4802 3.08591 11.4802 3.50012C11.4802 3.91434 11.1444 4.25012 10.7302 4.25012H6C4.75736 4.25012 3.75 5.25748 3.75 6.50012V19.5001C3.75 19.9143 3.41421 20.2501 3 20.2501C2.58579 20.2501 2.25 19.9143 2.25 19.5001V6.50012Z"
    }, null, -1),
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M10.458 3.77078C10.458 2.72159 11.2486 1.75012 12.3664 1.75012H15.8416C16.9594 1.75012 17.75 2.72159 17.75 3.77078V10.123C17.75 10.5997 17.5112 11.0732 17.0738 11.3299C16.6248 11.5935 16.0733 11.5616 15.6568 11.257L14.104 10.1215L12.5512 11.257C12.1347 11.5615 11.5832 11.5935 11.1342 11.3299C10.6969 11.0732 10.458 10.5997 10.458 10.123V3.77078ZM12.3664 3.25012C12.2046 3.25012 11.958 3.41643 11.958 3.77078V9.83248L13.6613 8.58694C13.925 8.39414 14.2831 8.39414 14.5467 8.58694L16.25 9.8325V3.77078C16.25 3.41643 16.0034 3.25012 15.8416 3.25012H12.3664Z"
    }, null, -1),
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M16.25 3.50012C16.25 3.08591 16.5858 2.75012 17 2.75012H20C20.9665 2.75012 21.75 3.53362 21.75 4.50012V20.5001C21.75 21.4666 20.9665 22.2501 20 22.2501H5C3.48122 22.2501 2.25 21.0189 2.25 19.5001C2.25 17.9813 3.48122 16.7501 5 16.7501H20.25V4.50012C20.25 4.36205 20.1381 4.25012 20 4.25012H17C16.5858 4.25012 16.25 3.91434 16.25 3.50012ZM20.25 18.2501H5C4.30964 18.2501 3.75 18.8098 3.75 19.5001C3.75 20.1905 4.30964 20.7501 5 20.7501H20C20.1381 20.7501 20.25 20.6382 20.25 20.5001V18.2501Z"
    }, null, -1)
  ])))
}
export default { render: render }